<template>
  <div class="Problem">
    <r_header></r_header>
    <div class="title htitle fs26">{{title}}</div>
    <div class="toc">
      <div class="prob" v-for="p in problems" @click="scrollTo(p.question)">
        {{p.question}}
      </div>
    </div>
    <div class="full">
      <div class="ppp" v-for="p in problems" :ref="p.question">
        <question :problem="p" ></question>
      </div>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src

 import Question from '@/components/problem/Question.vue';
 import RHeader from '@/components/frontpage/Header.vue';

 export default {
   name: 'Problem',
   computed: {
     title() {
       return '常见问题'
     },
     problems() {
       return this.$store.state.problem.questions;
     }
   },
   methods: {
     scrollTo(refName){
       let element = this.$refs[refName];
       let top = element[0].offsetTop;
       window.scrollTo(0, top-80);
     }
   },

   components: {
     r_header: RHeader,
     question: Question
   }
 }
</script>

<style scoped>
 .Problem{
   padding-bottom: 2vw;
 }
 .title{
   margin-top: 5vw;
   line-height: 3.6vw;
 }
 .title, .toc{
   width: 41.9vw;
   margin-left: auto;
   margin-right: auto;
 }
 .toc > .prob{
   line-height: 2.6vw;
   color: blue;
   display: list-item;
   margin-left: 1em;
   cursor: pointer;
 }

 .full{
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-left: 3vw;
 }
 .ppp:last-child>div{
   border-bottom: none;
 }
</style>